import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import { isLocalParticipantModerator } from 'jitsi/base/participants/functions';
import Popover from 'jitsi/base/popover/components/Popover.web';
import ConnectionIndicatorContent from 'features/connection-indicator/ConnectionIndicatorContent';
import { ConnectionIndicator, _mapStateToProps as mapStateToParentProps, } from 'jitsi/connection-indicator/components/web/ConnectionIndicator';
const styles = (theme) => {
    return {
        container: {
            display: 'inline-block',
        },
        hidden: {
            display: 'none',
        },
        icon: {
            padding: '4px',
            borderRadius: '4px',
            '&.status-high': {
                backgroundColor: theme.palette.success01,
            },
            '&.status-med': {
                backgroundColor: theme.palette.warning01,
            },
            '&.status-low': {
                backgroundColor: theme.palette.iconError,
            },
            '&.status-disabled': {
                background: 'transparent',
            },
            '&.status-lost': {
                backgroundColor: theme.palette.ui05,
            },
            '&.status-other': {
                backgroundColor: theme.palette.action01,
            },
        },
        inactiveIcon: {
            padding: 0,
            borderRadius: '50%',
        },
    };
};
class IISightConnectionIndicator extends ConnectionIndicator {
    render() {
        const { enableStatsDisplay, participantId, statsPopoverPosition, classes, t } = this.props;
        const visibilityClass = this._getVisibilityClass();
        if (this.props._popoverDisabled)
            return React.createElement(React.Fragment, null);
        return (React.createElement(Popover, { className: clsx(classes.container, visibilityClass), content: React.createElement(ConnectionIndicatorContent, { inheritedStats: this.state.stats, participantId: participantId }), disablePopover: !enableStatsDisplay, headingLabel: t('videothumbnail.connectionInfo'), id: 'participant-connection-indicator', onPopoverClose: this._onHidePopover, onPopoverOpen: this._onShowPopover, position: statsPopoverPosition, visible: this.state.popoverVisible }, this._renderIndicator()));
    }
}
export function _mapStateToProps(state, ownProps) {
    return {
        ...mapStateToParentProps(state, ownProps),
        _popoverDisabled: !isLocalParticipantModerator(state) ||
            Boolean(state['features/base/config'].connectionIndicators?.disableDetails),
    };
}
export default connect(_mapStateToProps)(translate(withStyles(styles)(IISightConnectionIndicator)));
